import { render, staticRenderFns } from "./promoFooter.vue?vue&type=template&id=54787faa&scoped=true&"
import script from "./promoFooter.vue?vue&type=script&lang=js&"
export * from "./promoFooter.vue?vue&type=script&lang=js&"
import style0 from "./promoFooter.vue?vue&type=style&index=0&id=54787faa&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54787faa",
  null
  
)

export default component.exports